import * as React from 'react';

import {ProfilePageContainer} from './containers';
import {useParams} from "react-router";

interface RouterParams {
    id: string;
}

export const ProfilePage: React.FC<RouterParams> = (props) => {
    const {id} = useParams<RouterParams>();

    return (
        <ProfilePageContainer id={parseInt(id)} />
    );
};
